module.exports = __webpack_public_path__ + "static/media/facebook.fde6a583.svg";